<template>
    <Dialog
        header="Importante"
        :modal="true"
        v-model:visible="abrir_modal"
        :closable="true"
        class="col-12 sm:col-12 md:col-6"
    >
        <div class="solicitud-paso-6-razon-social">
            <div class="solicitud-paso-6-razon-social-imagen">
                <img src="/images/car.png" />
            </div>
            <div class="solicitud-paso-6-razon-social-texto">
                Necesitamos esta información ya que, en caso de ser autorizada,
                tu solicitud contendrá los datos proporcionados y solo será
                válida para el vehículo elegido.
            </div>
        </div>
        <template #footer>
            <Button
                label="¡Listo!"
                icon="fas fa-check"
                class="p-button-info p-mr-2 p-button-rounded"
                v-tooltip.bottom="'¡Listo!'"
                @click="abrir_modal = false"
            />
        </template>
    </Dialog>
</template>

<script>
export default {
    name: "solicitud-paso-6-razon-social-component",
    props: {},
    data() {
        return {
            abrir_modal: false,
        };
    },
    methods: {},
    validations() {},
    mounted() {
        this.emitter.on("solicitud-paso-6-razon-social", () => {
            this.abrir_modal = true;
        });
    },
};
</script>

<style>
.solicitud-paso-6-razon-social {
    padding: 0 15px;
    display: flex;
}

.solicitud-paso-6-razon-social-imagen {
    width: 25%;
}

.solicitud-paso-6-razon-social-imagen img {
    padding: 10px;
}

.solicitud-paso-6-razon-social-texto {
    padding: 0 20px;
    width: 75%;
    font-weight: bold;
    font-size: 25px;
}

.icono-mas {
    font-size: 40px !important;
    color: #689f38;
}

.icono-menos {
    font-size: 40px !important;
    color: #d32f2f;
}

@media screen and (max-width: 520px) {
    .solicitud-paso-6-razon-social {
        flex-wrap: wrap;
    }
    .solicitud-paso-6-razon-social-imagen,
    .solicitud-paso-6-razon-social-texto {
        width: 100%;
    }

    .solicitud-paso-6-razon-social-imagen img {
        margin: 0 auto;
    }
}
</style>
